import { ReactNode } from 'react';

import { Flex, Text } from '@spotify-internal/encore-web';
import { Spinner } from '@spotify/confidence-core-react';

import styles from './PreviewShell.module.css';

interface PreviewShellProps {
  loading?: boolean;
  error?: unknown;
  children: ReactNode;
}

export const PreviewShell = ({
  loading,
  error,
  children,
}: PreviewShellProps) => {
  if (loading) {
    return (
      <div className={styles.loading}>
        <Spinner size={24} />
      </div>
    );
  }
  if (error) {
    return (
      <Text variant="bodySmall" semanticColor="textSubdued">
        Could not load preview.
      </Text>
    );
  }
  return (
    <Flex direction="column" gap="base">
      {children}
    </Flex>
  );
};
